/* eslint func-style: "off" */

import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import {
  // Actions
  FETCH_ZCCS, ADD_ZCC, EDIT_ZCC, DELETE_ZCC,
  // Action Creators
  fetchZccsSucceeded, fetchZccsFailed,
  addZccSucceeded, addZccFailed,
  editZccSucceeded, editZccFailed,
  deleteZccSucceeded, deleteZccFailed } from './Zccs.ducks';
import apiClient from 'helpers/apiClient';


export const fetchZccs = function* (action) {
  try {
    const accountId = action.payload.accountId;
    const path = `/api/accounts/${accountId}/command-centers`;
    const payload = yield call(apiClient, path);
    yield put(fetchZccsSucceeded(payload));
  } catch (e) {
    yield put(fetchZccsFailed(e.body));
  }
};

export const addZcc = function* (action) {
  try {
    const accountId = action.payload.accountId;
    const path = `/api/accounts/${accountId}/command-centers`;
    const payload = yield call(apiClient, path, {
      method: 'POST',
      body: JSON.stringify(action.payload)
    });
    yield put(addZccSucceeded(payload));
  } catch (e) {
    yield put(addZccFailed(e.body));
  }
};

export const editZcc = function* (action) {
  try {
    const accountId = action.payload.accountId;
    const id = action.payload._id;
    const path = `/api/accounts/${accountId}/command-centers/${id}`;
    const payload = yield call(apiClient, path, {
      method: 'PUT',
      body: JSON.stringify(action.payload)
    });
    yield put(editZccSucceeded(payload));
  } catch (e) {
    yield put(editZccFailed(e.body));
  }
};

export const deleteZcc = function* (action) {
  try {
    const accountId = action.payload.accountId;
    const id = action.payload._id;
    const path = `/api/accounts/${accountId}/command-centers/${id}`;
    const payload = yield call(apiClient, path, {
      method: 'DELETE'
    });
    yield put(deleteZccSucceeded(payload));
  } catch (e) {
    yield put(deleteZccFailed(e.body));
  }
};

export const fetchZccsSaga = function* () {
  yield takeLatest(FETCH_ZCCS, fetchZccs);
};

export const addZccSaga = function* () {
  yield takeLatest(ADD_ZCC, addZcc);
};

export const editZccSaga = function* () {
  yield takeLatest(EDIT_ZCC, editZcc);
};

export const deleteZccSaga = function* () {
  yield takeLatest(DELETE_ZCC, deleteZcc);
};

const sagas = function* () {
  yield all([
    fork(fetchZccsSaga),
    fork(addZccSaga),
    fork(editZccSaga),
    fork(deleteZccSaga)
  ]);
};

export default sagas;
